// removed by extract-text-webpack-plugin
module.exports = {"root":"_2CvTI","selected":"_3lIfs","price":"_3gLgU"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/TokenPack/components/TokenDropdownItem/TokenDropdownItem.scss
// module id = 1342
// module chunks = 3